export default {
  'services': {
    'firebase': {
      'apiKey': process.env.VUE_APP_FIREBASE_API_KEY,
      'authDomain': process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      'databaseURL': process.env.VUE_APP_FIREBASE_DATABASE_URL,
      'projectId': process.env.VUE_APP_FIREBASE_PROJECT_ID,
      'storageBucket': process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      'messagingSenderId': process.env.VUE_APP_FIREBASE_SENDER_ID
    },
    'gmail': {
      'email': process.env.VUE_APP_GMAIL_EMAIL,
      'password': process.env.VUE_APP_GMAIL_PASSWORD
    }
  }
}
